app.directive('cartFormSfexpress', [
  '$timeout'
  '$compile'
  'checkoutService'
  'cart'
  '$q'
  '$rootScope'
  (
    $timeout
    $compile
    checkoutService
    cart
    $q
    $rootScope
  ) ->
    {
      restrict: 'A'
      scope: {
        type: "@"
        defaultLocationCode: "@"
        getLocationCallback: "&onLocationChange"
      }
      link: (scope, element, attrs) ->
        scope.availableSfLocations = []
        $sfexpress = element
        $sfexpress
          .find("#sf-express-location select")
          .attr("ng-model", "location_code")
          .attr("ng-options", "location.code as (location.name_translations| translateModel) for location in availableSfLocations")
          .attr("ng-change", "onSfLocationChange()")
          .attr("ng-disabled", "!availableSfLocations")
        $sfexpress.html($compile($sfexpress.html())(scope))

        element.on 'change', 'select[name="delivery[sfexpress][district]"]', (event) ->
          scope.location_code = undefined
          scope.onSfLocationChange()
          setLocations()

        setLocations = () ->
          locations = try
                        JSON.parse($('#sfexpress-locations-data').val())
                      catch error
                        [] # Catch error when the method is called on re-rendering

          name = checkoutService.getElement('delivery[sfexpress][district]').val()
          district = _.find(locations, ((d) -> return true for lang, district_name of d.district_translations when district_name is name; return false ))
          $timeout((() -> scope.availableSfLocations = district.locations), 0) if district?

        scope.onSfLocationChange = () ->
          return if scope.defaultLocationCode == scope.location_code
          scope.defaultLocationCode = scope.location_code
          location = _.find(scope.availableSfLocations, (l) -> return l.code == scope.location_code)

          deliveryData = if location? then { location_code: scope.location_code, sfexpress_type: scope.type } else null
          scope.getLocationCallback()(deliveryData) if scope.getLocationCallback()?
          $rootScope.$emit('cart.form.sfexpress.location.change', scope.location_code)

        scope.$on "checkout.cart.form.rerender", () ->
          element.off()
          watcher() if watcher?

        initialize = () ->
          scope.location_code = scope.defaultLocationCode
          scope.onSfLocationChange()
          setLocations()

        # Listen to angular digest cycle
        registered = false
        watcher = scope.$watch () ->
          return if registered
          registered = true
          scope.$$postDigest () ->
            registered = false
            if checkoutService.getElement('delivery[sfexpress][district]')
              watcher()
              initialize()
          if $('#sf-express-location').length
            $rootScope.$emit('cart.form.sfexpress.location.change', scope.location_code)

        initialize()
    }
])